// The server names the download `secrets-<vault-name>.csv` in Content-Disposition, which the fetcher does
// not expose, so the same reduction to `a-z0-9-` is repeated here.
export const vaultExportFileName = (vaultName: string) => {
    const slug = vaultName
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');

    return slug ? `secrets-${slug}.csv` : 'secrets.csv';
};
